export function loginErrorMessage(error) {
    const response = error && error.response;
    const status = response ? response.status : undefined;
    const data = response ? response.data : undefined;
    let detail = "";
    if (typeof data === "string") {
        detail = data;
    } else if (data && typeof data.detail === "string") {
        detail = data.detail;
    } else if (data && typeof data.error === "string") {
        detail = data.error;
    }

    if (status === 401) {
        return "Invalid email or password";
    }
    if (status === 403 && /csrf/i.test(detail)) {
        return "Sign-in was blocked because the security token was missing or out of date. Refresh the page and try again.";
    }
    if (status === 403) {
        if (detail && !detail.includes("<")) {
            return detail;
        }
        return "Sign-in was blocked before the password was checked. Refresh the page and try again.";
    }
    return "Unable to sign in. Try again.";
}
